export default __webpack_public_path__ + "static/media/YAS0220.34I-22780_-15208_0.4e4f61c4.jpg";